interface Props {
  error: any;
}
export function Error({ error }: Props) {
  return (
    <div>
      <div className="w-full my-[10%] text-center">
        <h1>Error</h1>
        message : {error.message}
      </div>
    </div>
  );
}
